import { AbstractControl, ValidationErrors } from '@angular/forms';

export function RequireAccessControl(control: AbstractControl): ValidationErrors | null {
  const roles = control['controls'].map(control => (control.controls.role.value));

  if (roles.every(role => role === 'none')) return { requireAccessControl: true };
  return null;
}
